export default __webpack_public_path__ + "static/media/__business_icon.da3a2ce6.svg";